<template>
    <div v-show="show" class="backdrop">
        <div class="popup-container">
            <div class="header">
                <div class="header-bg">
                    <div class="no-subscriber">
                        {{ $t('popup.notSubscriber') }}
                    </div>
                </div>
                <div class="close" @click="closePopUp">
                    <img src="@/assets/popup/close.svg" alt="close">
                </div>
            </div>
            <div class="main-content">
                <div class="interested-question">
                    {{ $t('popup.interestedQuestion') }}
                </div>
                <div class="form-description">
                    <div>{{ $t('popup.formDescription') }}</div>
                </div>
                <div class="submission-error mt-1">{{ submissionError }}</div>
                <form class="form" @submit.prevent="submitForm">
                    <div class="form-input-control">
                        <b-form-input ref="fullnameInput" v-model="potentialCustomer.fullName" class="form-input first" type="text" placeholder="ΟΝΟΜΑΤΕΠΩΝΥΜΟ" required :disabled="disabledForm || success" />
                    </div>
                    <span v-if="invalidFullName" class="error">{{ $t('popup.fullNameMissing') }}</span>
                    <div class="form-input-control">
                        <input v-model="potentialCustomer.phoneNumber" class="form-input" type="text" placeholder="ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ" maxlength="10" required :disabled="disabledForm || success || !validateFullName()">
                        <span v-if="invalidPhone || !validatePhoneRegex()" class="error">{{ $t('popup.phoneError') }}</span>
                    </div>
                    <div class="form-input-control">
                        <select
                            v-model="potentialCustomer.timeFrame"
                            class="form-input"
                            required
                            :disabled="disabledForm || success || (potentialCustomer.phoneNumber.length <= 2 || !validatePhoneRegex())"
                        >
                            <option disabled value="">{{ $t('popup.timeFramePrefer') }}</option>
                            <option
                                v-for="timeFrameOption in timeFrameOptions"
                                :key="timeFrameOption.label"
                                :value="timeFrameOption.label"
                            >{{ timeFrameOption.label }}</option>
                        </select>
                    </div>
                    <router-link v-slot="{ href }" to="/Πολιτική Προστασίας Προσωπικών Δεδομένων.pdf" target="_blank">
                        <a :href="href">
                            <pre class="privacy-policy mt-4">{{ $t('privacyPolicy') }}</pre>
                        </a>
                    </router-link>
                    <button type="submit" class="form-btn" :disabled="disabledForm || success || ((potentialCustomer.phoneNumber.length <= 2 || !validatePhoneRegex()) || !validateFullName() || potentialCustomer.timeFrame.length < 2)">{{ $t('popup.submit') }}</button>
                    <div v-show="success" class="success">{{ $t('referralForm.success') }}</div>
                </form>
            </div>
            <div class="footer">
                <div class="float-right" style="margin-top: -30px;">
                    <router-link v-slot="{ href }" to="/Συχνές Ερωτήσεις.pdf" target="_blank">
                        <a :href="href">
                            <span class="instructions-btn">{{ $t('headerBar.instructions') }} </span>
                        </a>
                    </router-link>
                </div>
                <div class="footer-bg" />
                <div class="terms">
                    <!-- <router-link v-slot="{ href }" to="/Όροι & Προϋποθέσεις - Σελίδα Συστήνοντα.pdf" target="_blank">
                        <a :href="href">
                            <span class="term-title">{{ $t('popup.terms') }}</span>
                        </a>
                    </router-link> -->
                    <small class="d-block disc">
                        {{ $t('disclaimer') }}
                    </small>
                    <span class="term-info">{{ $t('popup.databaseSync') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import potentialCustomerService from '@/services/potential-customer-service'
    import phoneService from '@/services/phone-service'
    export default {
        props: {
            show: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                potentialCustomer: {
                    fullName: '',
                    phoneNumber: '',
                    email: null,
                    timeFrame: ''
                },
                submissionError: null,
                timeFrameOptions: [],
                invalidPhone: false,
                invalidFullName: false,
                success: false,
                disabledForm: false
            }
        },
        created() {
            potentialCustomerService.getTimeFrames().then(res => {
                this.timeFrameOptions = res.content
            })
        },
        mounted() {
            // this.$refs.fullnameInput.blur()
        },
        methods: {
            async submitForm() {
                this.validateForm()
                const validPhone = await this.validatePhone()
                this.invalidPhone = false
                if (!validPhone.content || !this.validateFullName()) {
                    this.invalidPhone = true
                    return
                }

                const isUnique = await potentialCustomerService.phoneExists(this.potentialCustomer.phoneNumber)
                if (!isUnique.content) {
                    this.showError('Το αίτημα σας έχει υποβληθεί')
                    this.disabledForm = true
                    return
                }
                this.showError('')
                potentialCustomerService.potentialCustomerSubmit(this.potentialCustomer).then(res => {
                    this.success = true
                }).catch(err => {
                    this.showError(err.response.data.message)
                })
            },
            validatePhone() {
                return phoneService.isValid(this.potentialCustomer.phoneNumber)
            },
            closePopUp() {
                this.success = false
                this.potentialCustomer.fullName = ''
                this.potentialCustomer.phoneNumber = ''
                this.potentialCustomer.timeFrame = ''
                this.$parent.showPopup = false
                this.disabledForm = false
                this.submissionError = ''
            },
            validateFullName() {
                if (this.potentialCustomer.fullName.length < 2) {
                    return false
                }

                return true
            },
            validatePhoneRegex() {
                const reg = /\d{10}$/
                if (this.potentialCustomer.phoneNumber.length > 2 && !this.potentialCustomer.phoneNumber.match(reg)) {
                    return false
                }
                return true
            },
            validateForm() {
                this.invalidFullName = false
                if (!this.validateFullName()) {
                    this.invalidFullName = true
                    return false
                }
            },
            showError(message) {
                this.submissionError = message
                // setTimeout(() => { this.submissionError = null }, 8000)
            }
        }
    }
</script>

<style scoped>
/* .instr {
    color: #000;
    z-index: 9999;
    position: relative;
}
.instructions-btn {
    float: right;
    margin-right: .4em;
    font-size: 1em;
    color: #000;
    text-decoration: underline;
    margin-top: -15px;
} */
.instructions-btn {
    margin-right: .5rem;
    text-align: center;
    background: #fff;
    font-size: 1.05rem;
    padding: 5px 10px;
    border-radius: 4px;
    box-shadow: 0px 3px 6px #00000029;
    cursor: pointer;
    color: #212529;
}
.terms-info {
    margin-top: -1.5em;
    padding: 2% 10%;
    color: #2B2828;
    text-decoration: underline;
}
.backdrop {
    width: 100%;
    height: 100vh;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(23px);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
}
.popup-container {
    position: relative;
    width: 69%;
    max-width: 885px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #2B2828;
    font-family: 'RobotoRegular';
    margin: auto;
    overflow-y: auto;
    height: 100vh;
}
.header {
    width: 100%;
}
.disc {
    font-size: 0.8rem;
    color: #505050;
}
.header-bg {
    width: 100%;
    background: url('~@/assets/popup/popup-header.png');
    height: 19vh;
    background-position: center;
}
.close {
    position: absolute;
    top: -3px;
    right: 2%;
    padding: 1rem;
    cursor: pointer;
    opacity: 1;
}
.main-content {
    background-color: #fff;
    flex: 1 0 auto;
}
.no-subscriber {
    font-size: 1.875rem;
    text-align: center;
}
.interested-question {
    font-family: 'RobotoBold';
    font-size: 1rem;
    letter-spacing: 0.41px;
    width: 70%;
    margin: auto;
    padding-top: 2%;
}
.form-description {
    letter-spacing: 0.34px;
    font-size: 1.4rem;
    width: 70%;
    margin: auto;
    margin-top: 1rem;
}
.disclaimer {
    width: 85%;
    margin: auto;
}
.form {
    display: flex;
    flex-direction: column;
    width: 80%;
    max-width: 630px;
    margin: 0 auto;
}
.form-input-control {
    position: relative;
}
.form-input-control:first-child {
    margin-top: 5%;
}
.form-input-control + .form-input-control {
    margin-top: 4%;
}
.form-input {
    border: 3px solid #004996;
    width: 100%;
    border-radius: 6px;
    padding: 5px 21px;
    font-size: 1.75rem;
}
.form-input:disabled {
    background: rgb(143, 143, 143);
    color: rgb(207, 207, 207)!important;
    opacity: .6;
}
.form-input:disabled::placeholder, select:disabled {
    color: rgb(207, 207, 207)!important;
}
select {
    background: #fff;
}
.form-input-control .error {
    font-family: 'Comfortaa';
}
.form-input::placeholder {
    color: rgb(139, 139, 139, .6)!important;
    font-family: 'RobotoRegular';
}
.error {
    color: #a70000!important;
    display: block;
    margin-bottom: -20px;
}
.submission-error {
    text-align: center;
    color: rgb(240, 70, 70);
}
.form-btn {
    margin: 2% auto 3%;
    min-width: 40%;
    max-width: 240px;
    height: 100%;
    max-height: 60px;
    background-color: #004996;
    border-radius: 8px;
    border: none;
    box-shadow: 0px 3px 6px #0000005E;
    color: #fff;
    font-size: 2.125rem;
    font-family: 'RobotoBold';
    letter-spacing: 0.68px;
    transition: all 0.15s ease-in-out
}
.form-btn:hover {
    background-color: #0660c0;
}
.form-btn:active {
    transform: scale(0.9)
}
.form-btn:disabled {
    background: grey;
    opacity: .3;
}
.footer {
    position: relative;
    background-color: #fff;
    width: 100%;
    border-radius: 0 0 13px 13px;
}
.footer-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: linear-gradient(142deg, rgba(251,231,61,0.33) 0%, rgba(251,178,51,0.33) 50%, rgba(196,124,0,0.33) 100%);
    clip-path: polygon(0 0, 100% 30%, 100% 100%, 0% 100%);
    border-radius: 0 0 13px  13px;
}

.terms {
    padding: 2% 10%;
    position: relative;
    z-index: 2;
}
a {
    color: #000;
}
.term-title {
    font-size: 1.125rem;
    text-decoration: underline;
}
.term-info {
    font-size: 0.938rem;
    color: #505050;
}
.success {
    text-align: center;
    margin-top: 1rem;
    font-size: 1.2rem;
}
.privacy-policy {
    text-decoration: underline;
    font-size: .8rem;
    text-align: center;
    text-decoration-skip-ink: none;
    font-family: 'RobotoRegular';
}
@media screen and (max-width: 790px) {
    .terms-info {
        font-size: .6em;
    }
    .terms {
        font-size: .8em;
        color: red;
    }
    .instructions-btn {
        font-size: .7em;
    }
}
@media screen and (max-width: 1150px) {
    .terms-info {
        font-size: .9em;
    }
    .no-subscriber {
        font-size: 1.5rem;
        width: 80%;
        margin: auto;
    }
    .interested-question {
        font-size: 1rem;
        margin: 1rem auto;
        width: 85%;
    }
    .form-description {
        margin: 1rem auto;
        width: 85%;
        font-size: 1.2rem;
    }
    .form-input {
        padding: 5px 15px;
        font-size: 1.5rem;
    }
    .form-btn {
        font-size: 1.6rem;
    }
    .term-title {
        font-size: 1rem;
    }
    .term-info {
        font-size: 0.9rem;
    }
}
@media screen and (max-height: 800px) {
    .interested-question {
        font-size: 0.9rem;
    }
    .form-description {
        font-size: 1rem;
    }
    select.form-input {
        padding: 5px 21px;
        font-size: 1.55rem;
    }
    .form-input {
        padding: 2px 21px;
        font-size: 1.55rem;
    }
    .header-bg {
        background-position: 40% 20%;
    }
    .terms {
        padding: 1% 10%;
    }
}
@media screen and (max-width: 510px) {
    .terms-info {
        font-size: .7em;
    }
    .disc {
        font-size: .7rem;
        margin-bottom: -.5rem;
        margin-top: 0.7rem;
    }
    .form-input.first {
        margin-top: 0px;
    }
    .popup-container {
        width: 95%;
    }
    .no-subscriber {
        font-size: 1.2rem;
    }
    .interested-question {
        font-size: .9rem;
        padding-left: 0px;
        width: 80%;
    }
    .disclaimer {
        padding-left: 0px;
    }
    .form-description {
        font-size: .9rem;
        width: 80%;
    }
    .form-input {
        font-size: 1.1rem;
    }
    .form-btn {
        font-size: 1.5rem;
    }
    .term-title {
        font-size: 0.8rem;
    }
    .term-info {
        font-size: 0.6rem;
    }
    .close {
        right: -2%;
        top: -1%;
    }
    select.form-input {
        padding: 7px 21px;
        font-size: 1.1rem;
    }
    .error {
        margin-bottom: -10px;
        font-size: .9rem;
    }
    .success {
        margin-top: 0px;
    }
}
</style>
